import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { color, typography } from 'styled-system';
import { Box } from '../grid/Grid';

const StyledText = styled(Box)`
  ${color}
  ${typography}
  ${props => props.isTruncated && ellipsis()}
`;

export const Text = forwardRef(({ m = 0, ...props }, ref) => (
  <StyledText ref={ref} as="p" m={m} {...props}></StyledText>
));

Text.defaultProps = {
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: 1.5,
};
